import React from 'react'
import { Box, Button, Container, InputAdornment, Typography, useTheme } from '@mui/material'
import CustomInput from '../../Components/Input/CustomInput';
import { IoChevronForwardOutline, IoMailOutline } from 'react-icons/io5';

const ResetPassword = () => {
  const R = useTheme().palette.dash;
  const T = useTheme().palette.dash;

  return (
    <Box sx={{ backgroundColor: T.pageBg, minHeight: '100vh' }}>
      <Container maxWidth='sm' sx={{padding: "2% 0"}}>
        <Box sx={{ ...R.card, padding: 3 }}>
          <Typography variant='h6'>Reset Password</Typography>
          <Typography color='text.secondary'>A password reset link will be sent to the email entered below</Typography>
          <Box sx={{display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 2, padding: '3% 0'}}>
          <CustomInput placeholder='E-mail' id="email" label="Email Address"
              InputProps={{
                  startAdornment: (
                      <InputAdornment position='start'>
                          <IoMailOutline />
                      </InputAdornment>
                  )
              }}
          />
          </Box>
          <Box sx={{width: "100%", display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "3%"}}>
            <Button variant='accent' sx={{gap: 2}}>Send Link<IoChevronForwardOutline style={{fontWeight: "bolder", fontSize: '1.1rem'}} /></Button>
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default ResetPassword
